import React from 'react';
import { Icon } from './Icon.js';
export const IconFileCheck = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 2V10H4", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M13 19L16 22L21 17", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M21 12.7568L19 14.7568V3H11.0059L5 9.00391V21H10.7568L12.7568 23H3V8.17578L3.29297 7.88281L9.88477 1.29297L10.1777 1H21V12.7568Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconFileCheck.js.map